// extracted by mini-css-extract-plugin
module.exports = {"postoverview":"postOverview-module--postoverview--3l1L9","cover":"postOverview-module--cover--32wZv"};